<template>
    <page>
        <module :title="`话题 【${detailInfo.title || ''}】跟帖内容详情`">
            <c-detail title="基础信息">
                <c-detail-item label="发布用户头像"><c-image :src="detailInfo.head_photo" size="40" preview></c-image></c-detail-item>
                <c-detail-item label="发布用户昵称">{{detailInfo.nick_name}}</c-detail-item>
                <c-detail-item label="发布用户手机号">{{detailInfo.user_manage_mobilephone}}</c-detail-item>
                <c-detail-item label="点赞总数">{{detailInfo.thumb_count}}</c-detail-item>
<!--                <c-detail-item label="评论总数"><a class="s-link" @click="showComment(detailInfo)">{{detailInfo.comment_count}}</a></c-detail-item>-->
                <c-detail-item label="评论总数">
                  <template>
                        <span v-if="detailInfo.comment_count > 0">
                            <a class="s-link" @click="navigateTo(`/moments_comment?comment_id=${detailInfo.id}`)">
                                &nbsp;{{detailInfo.comment_count}} &nbsp;
                            </a>
                        </span>
                    <span v-else>0</span>
                  </template>
                </c-detail-item>
                <c-detail-item label="浏览总人数">{{detailInfo.pv}}</c-detail-item>
                <c-detail-item label="收藏总人数">{{detailInfo.collect_count}}</c-detail-item>
                <c-detail-item label="发布时间">{{detailInfo.create_date}}</c-detail-item>
            </c-detail>

            <c-detail title="话题跟帖内容">
                <c-detail-item label="归属话题" full>{{detailInfo.title}}</c-detail-item>
                <c-detail-item label="跟帖内容" full>{{detailInfo.content}}</c-detail-item>
                <c-detail-item label="媒体文件" full>
                    <div  class="img-list flex-wrap">
                        <c-image v-for="(item, j) in mediaList" :key="j" class="img" :src="item" size="80" preview></c-image>
                    </div>
                </c-detail-item>

            </c-detail>
        </module>

        <c-dialog ref="commentDialog" title="评论信息" width="1000" :button="false">
            <m-search ref="commentSearch" @search="updateComment">
                <c-form ref="commentForm" inline>
                    <c-form-item type="input" label="用户昵称" name="nick_name"></c-form-item>
                    <c-form-item type="input" label="评论内容" name="content"></c-form-item>
                </c-form>
            </m-search>

            <c-table ref="commentList" height="600">
                <c-table-column
                        label="评价类型"
                        width="100"
                        name="commend_type"
                >
                  <template v-slot="{data}">
                    <span v-if="data.commend_type == -2">回复评论</span>
                    <span v-if="data.commend_type == -1">--</span>
                    <span v-if="data.commend_type == 3">话题跟帖评论</span>
                    <span v-if="data.commend_type == 5">分享评论</span>
                  </template>
                </c-table-column>

                <c-table-column
                        label="用户信息"
                        width="200"
                >
                    <template v-slot="{data}">
                        <div class="flex-center-cross">
                            <c-image :src="data.head_photo" preview size="30" style="margin-right: 10px;"></c-image>
                            <span>{{data.nick_name}}</span>
                        </div>
                    </template>
                </c-table-column>

                <!--                <c-table-column
                                        label="评价对象"
                                        width="200"
                                        name="comment_content"
                                ></c-table-column>-->

                <c-table-column
                        label="内容"
                        width="450"
                        name="content"
                ></c-table-column>

                <c-table-column
                        label="评论时间"
                        name="create_date"
                        width="140"
                ></c-table-column>

                <c-table-column
                        type="button"
                        fixed="right"
                        label="操作"
                        width="100"
                >
                    <template v-slot="row">
                        <c-table-button @click="removeComment(row)">删除</c-table-button>
                    </template>
                </c-table-column>
            </c-table>
        </c-dialog>
    </page>
</template>

<script>
    import pagination from '@/components/public/pagination.vue'

    export default {
        name: 'moments_topic_follow_detail',

        components: {
            pagination
        },

        props: {
            id: String
        },

        data() {
            return {
                detailInfo: {},
                noteList: [],
                noteTotal: 0,
                mediaList: []
            }
        },

        watch: {
            id() {
                this.updateDetail();
            }
        },

        mounted() {
            this.updateDetail();
        },

        methods: {
            updateDetail() {
                this.request({
                    url: '/moments/detail',
                    data: {
                        id: this.id
                    },
                    success: data => {
                        this.detailInfo = data;
                        this.mediaList = data.media_list || [];
                    }
                });
            },

            updateList(data) {
                this.request({
                    url: '/moments/detail_list',
                    data: Object.assign(data, {
                        id: this.id
                    }),
                    success: data => {
                        this.noteList = data;
                    },
                    response: res => {
                        this.noteTotal = res.total;
                    }
                });
            },

            removeNote(item) {
                this.$confirm({
                    text: '确定要删除此话题吗？',
                    resolve: () => {
                        this.request({
                            url: '/moments/del_detail',
                            data: {
                                id: item.id
                            },
                            loading: true,
                            success: data => {
                                this.$refs.pagination.update();
                            }
                        });
                    }
                });
            },

            showComment(item) {
                this._noteId = item.id;
                this.$refs.commentForm.clear();
                this.$refs.commentSearch.search();
                this.$refs.commentDialog.open();
            },

            updateComment(data) {
                data.moments_id = this._noteId;
                this.$refs.commentList.load({
                    url: '/moments_comment/list',
                    data
                });
            },

            removeComment(row) {
                this.$confirm({
                    text: '确定要删除此评论吗？',
                    resolve: () => {
                        this.request({
                            url: '/moments_comment/del',
                            data: {
                                id: row.data.id
                            },
                            loading: true,
                            success: data => {
                                this.$refs.commentList.update();
                            }
                        });
                    }
                });
            }
        }
    }
</script>

<style lang="stylus" scoped>
  .list {
    margin-bottom: 10px;

    .item {
      border: 1px solid #eee;
      overflow: hidden;

      &:nth-child(n+2) {
        border-top: none;
      }

      .img-list {
        margin: 16px 22px 0;

        .img {
          margin-right: 12px;
        }
      }

      .content {
        margin: 16px 22px;
        line-height: 24px;
        color: #333;
      }

      .data {
        height: 40px;
        border-top: 1px solid #eee;
        padding: 0 12px 0 22px;
        font-size: 13px;
        color: #444;
        background: #F9F9F9;

        span {
          margin-right: 14px;
        }

        button {
          width: 40px;
          height: 24px;
          border: none;
          border-radius: 2px;
          font-size: 12px;
          color: #fff;
          background: #e00;

          &:hover {
            font-weight: bold;
          }
        }
      }
    }
  }

  .paging {
    position: sticky;
    bottom: 0;
  }
</style>